<template>
  <div>
    <v-sheet elevation="3" class="mt-6 mb-2">
      <div>
        <!-- <small>{{ this.slates }}</small> -->
        <v-data-table
          :headers="headers"
          :items="getPlayers"
          :item-key="playerDetails._id"
          class="elevation-1"
          height="850"
          sort-by="DraftKingsSalary"
          sort-desc
          :footerProps="footerProps"
        >
          <!-- checkbox -->
          <template
            v-slot:item.checkbox="{ item }"
            class="mt-n2"
            v-if="this.role === 'client'"
          >
            <v-checkbox
              color="success"
              v-model="item.isChecked"
              :id="'checkbox' + item._id"
              hide-details
              @change="topPlays($event, item)"
            ></v-checkbox>
          </template>
          <!-- checkbox -->

          <!-- OpponentRank -->
          <template v-slot:item.OpponentRank="{ item }" class="mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-avatar size="25" rounded v-on="on">
                  <v-icon
                    :style="[
                      item.OpponentRank <= 9
                        ? { color: 'red' }
                        : item.OpponentRank > 10 && item.OpponentRank <= 20
                        ? { color: 'black' }
                        : { color: 'green' },
                    ]"
                    >mdi-account-group-outline</v-icon
                  >
                </v-avatar>
                <p class="ml-1">{{ item.OpponentRank }}</p>
              </template>
              <span class="caption">Opponent Rank</span>
            </v-tooltip>
          </template>

          <!-- profile image -->
          <template v-slot:item.PhotoUrl="{ item }">
            <v-avatar width="37" height="48">
              <img :src="item.PhotoUrl" />
            </v-avatar>
          </template>
          <!-- profile image ends -->

          <!-- player name -->
          <template v-slot:item.Name="{ item }">
            <router-link
              :to="{
                name: 'PlayerDetail',
                params: { playerId: item.PlayerID, SportId: item.SportId },
              }"
              style="text-decoration: none"
              class="caption"
            >
              {{ item.Name }}
            </router-link>
            <!-- status -->
            <v-row justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-show="item.InjuryStatus == null"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <status-indicator status="positive" pulse />
                  </v-col>
                </template>
                <span>Healthy</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-show="item.InjuryStatus == 'Out'"
                    v-on="on"
                    v-bind="attrs"
                  >
                    <status-indicator status="negative" pulse />
                  </v-col>
                </template>
                <span>Out</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-on="on"
                    v-bind="attrs"
                    v-show="item.InjuryStatus == 'Questionable'"
                  >
                    <status-indicator status="intermediary" pulse />
                  </v-col>
                </template>
                <span>Questionable</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-col
                    cols="2"
                    md="3"
                    sm="1"
                    v-on="on"
                    v-bind="attrs"
                    v-show="
                      item.InjuryStatus == 'Probable' ||
                      item.InjuryStatus == 'Doubtful'
                    "
                  >
                    <status-indicator status="active" pulse />
                  </v-col>
                </template>
                <span>Probable</span>
              </v-tooltip>
            </v-row>
          </template>
          <!-- status ends-->
          <!-- player name ends -->

          <!-- position -->
          <template v-slot:item.DraftKingsPosition="{ item }">
            <p class="caption" v-if="slates[0].Operator == 'DraftKings'">
              {{ item.DraftKingsPosition }}
              <small class="caption" v-if="item.DepthChartOrder == '0'">
                1
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '1'">
                2
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '2'">
                3
              </small>
              <small v-else>3</small>
            </p>
            <p v-else class="caption">
              {{ item.FanDuelPosition }}
              <small class="caption" v-if="item.DepthChartOrder == '0'">
                1
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '1'">
                2
              </small>
              <small class="caption" v-else-if="item.DepthChartOrder == '2'">
                3
              </small>
              <small v-else>3</small>
            </p>
          </template>
          <!-- position ends -->

          <!-- salary -->
          <template v-slot:item.DraftKingsSalary="{ item }">
            <p
              v-if="slates[0].Operator == 'DraftKings'"
              class="caption green--text"
            >
              {{ item.DraftKingsSalary }}
            </p>
            <p v-else class="caption green--text">{{ item.FanDuelSalary }}</p>
          </template>
          <!-- salary ends -->

          <!-- matchup -->
          <template v-slot:item.Opponent="{ item }">
            <p
              class="caption"
              :style="[
                item.HomeOrAway == 'AWAY'
                  ? { color: 'black' }
                  : { color: 'black' },
              ]"
            >
              {{ item.Team }}&nbsp;
              <small class="black--text">@ </small>
              <span
                :style="[
                  item.HomeOrAway == 'HOME'
                    ? { color: 'black' }
                    : { color: 'black' },
                ]"
              >
                {{ item.Opponent }}
              </span>
            </p>
          </template>
          <!-- matchup ends -->

          <!-- Fp -->
          <template v-slot:item.FPPDdraftking="{ item }">
            <p class="caption" v-if="slates[0].Operator == 'DraftKings'">
              ${{ item.FPPDdraftking >> 0 }}
            </p>
            <p v-else class="caption">${{ item.FPPDfanduel >> 0 }}</p>
          </template>
          <!-- Fp ends -->

          <!-- FPPG -->
          <template v-slot:item.FPPG="{ item }">
            <p class="caption">{{ item.FPPG >> 0 }}</p>
          </template>
          <!-- FPPG ends -->

          <!-- projection -->
          <template v-slot:item.DraftKingsProjection="{ item }">
            <p v-if="slates[0].Operator == 'DraftKings'" class="caption">
              {{ item.DraftKingsProjection.toFixed(1) }}
            </p>
            <p v-else class="caption">
              {{ item.FandDualProjection.toFixed(1) }}
            </p>
          </template>
          <!-- projection ends -->

          <!-- fanDuelVal -->
          <template v-slot:item.FanDualVal="{ item }">
            <p v-if="slates[0].Operator == 'DraftKings'" class="caption">
              {{ item.DraftKingsVal.toFixed(2) }}
            </p>
            <p v-else class="caption">{{ item.FanDualVal.toFixed(2) }}</p>
          </template>
          <!-- fanDuelVal ends-->

          <!-- min% -->
          <template v-slot:item.min="{ item }">
            <v-text-field
              class="mt-1 minimun"
              :id="'min_' + item._id"
              dense
              solo
              placeholder="0"
              v-model="item.min"
              @blur="setExposure($event, item)"
              :disabled="item.type == 'lock'"
            ></v-text-field>
          </template>
          <!-- min% ends -->

          <!-- max% -->
          <template v-slot:item.max="{ item }">
            <v-text-field
              class="mt-1 maximum"
              :id="'max_' + item._id"
              solo
              dense
              placeholder="100"
              v-model="item.max"
              @blur="setExposure($event, item)"
              :disabled="item.type == 'lock'"
            ></v-text-field>
          </template>
          <!-- max% ends -->

          <!-- Player action(exclude, lock) block start -->
          <template v-slot:item.type="{ item }">
            <v-row class="mt-n3">
              <template v-if="item.type == 'lock'">
                <!-- lock player button-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      fab
                      dark
                      :id="'Lk_' + item._id + item.type"
                      color="green darken-3"
                      @click="unlockExposure($event, item)"
                    >
                      <v-icon>mdi-shield-lock-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Lock</span>
                </v-tooltip>

                <!--//* Position type for fanduel only.. -->
                <template
                  v-if="
                    slates[0].Operator == 'FanDuel' &&
                    $parent.radio == 'others' &&
                    item.type == 'lock'
                  "
                >
                  <small>
                    {{ checkPosition(exposure, item) }}
                  </small>
                </template>
                <!--//* Position type for fanduel only.. -->

                <!-- exclude player button -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      x-small
                      fab
                      :id="'Ex_' + item._id + item.type"
                      color="blue"
                      :disabled="true"
                      v-on="on"
                    >
                      <v-icon> mdi-window-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Exclude</span>
                </v-tooltip>
              </template>

              <template v-else>
                <!-- lock player button-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      fab
                      dark
                      :id="'Lk_' + item._id + item.type"
                      color="blue"
                      @click="lockExposure($event, item)"
                    >
                      <v-icon>mdi-shield-lock-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Lock</span>
                </v-tooltip>
                <!-- exclude player button -->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      x-small
                      fab
                      dark
                      :id="'Ex_' + item._id + item.type"
                      :color="item.type == 'exclude' ? 'red' : 'blue'"
                      v-on="on"
                      @click="setExclude($event, item)"
                    >
                      <v-icon> mdi-window-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Exclude</span>
                </v-tooltip>

                <!--//* Position type for fanduel only.. -->
                <template
                  v-if="
                    slates[0].Operator == 'FanDuel' &&
                    $parent.radio == 'others' &&
                    item.type == 'exclude'
                  "
                >
                  <small>
                    {{ checkPosition(exposure, item) }}
                  </small>
                </template>

                <!--//* Position type for fanduel only.. -->
              </template>
            </v-row>
          </template>
          <!-- Player action(exclude, lock) block end-->
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "NbaTopPlayersOptimizerTable",
  props: {
    playerDetails: {
      type: Array,
      default: [],
    },
    selectionD: {
      type: String,
      default: () => "",
    },
    selectionDS: {
      type: String,
      default: () => "",
    },
    selectionF: {
      type: String,
      default: () => "",
    },
    selectionFS: {
      type: String,
      default: () => "",
    },
    slates: {
      type: Array,
      default: [],
    },
    slateID: {
      type: String,
      default: "",
    },
    defaultSport: {
      type: String,
      default: "",
    },
    defaultOptimizer: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      footerProps: { "items-per-page-options": [15, 30, 50, -1] },
      headers: [
        {
          text: "",
          value: "checkbox",
        },
        {
          text: "Profile",
          value: "PhotoUrl",
          sortable: false,
          align: "start",
        },
        {
          text: "Player",
          value: "Name",
          sortable: false,
          align: "center",
          width: "50px",
        },
        { text: "Team", value: "Team", align: "start" },
        {
          text: "Position",
          value: "DraftKingsPosition",
          align: "start",
        },
        // { text: "DepthChart", value: "DepthChartOrder", align: "start" },
        { text: "Salary($)", value: "DraftKingsSalary", align: "start" },
        {
          text: "Match",
          value: "Opponent",
          sortable: false,
          align: "start",
        },
        { text: "", value: "OpponentRank", align: "start" },
        {
          text: "FP",
          value: "FPPDdraftking",
          align: "start",
          width: "30px",
        },
        // { text: "Val", value: "FanDualVal" },
        { text: "FPPG", value: "FPPG", align: "start", width: "30px" },
        {
          text: "Proj.",
          value: "DraftKingsProjection",
          align: "start",
          width: "30px",
        },
        {
          text: "Min%",
          value: "min",
          sortable: false,
          align: "start",
          width: "80px",
        },
        {
          text: "Max%",
          value: "max",
          sortable: false,
          align: "start",
          width: "80px",
        },
        {
          text: "",
          value: "type",
          align: "start",
          width: "110px",
          sort: (a, b) => {
            if (a > b) {
              // //console.log("a", a);
              return 1;
            }
            if (a < b) {
              // //console.log("b", b);
              return -1;
            }
            return 0;
          },
        },
      ],
      userId: localStorage.getItem("user"),
      role: localStorage.getItem("role"),
    };
  },

  computed: {
    ...mapState("NbaModule", ["exposure", "position"]),
    ...mapGetters("NbaModule", [
      "getFilterByPosition",
      "getFilterBySingle",
      "getFilterByPositionInFanduel",
    ]),

    getPlayers() {
      if (
        this.slates[0]?.Operator == "DraftKings" &&
        this.slates[0]?.OperatorGameType == "Classic"
      ) {
        return this.getFilterByPosition(this.selectionD);
      } else if (
        this.slates[0]?.Operator == "DraftKings" &&
        this.$parent.radio == "others"
      ) {
        return this.getFilterBySingle(this.selectionDS);
      } else if (
        this.slates[0]?.Operator == "FanDuel" &&
        this.$parent.radio == "others"
      ) {
        return this.getFilterByPositionInFanduel(this.selectionFS);
      } else if (
        this.slates[0]?.Operator == "FanDuel" &&
        this.slates[0]?.OperatorGameType == "Classic"
      ) {
        return this.getFilterByPosition(this.selectionF);
      }
    },
  },
  methods: {
    checkPosition(exposureArr, player) {
      if (exposureArr.length == 0) return;
      let finalValue = "";
      exposureArr.find((element) => {
        //  ;
        if (player.PlayerID == element.playerId && element.type !== "") {
          if (element.type !== "" && element.positiontype == "1") {
            finalValue = "(Mvp)";
            // return "Mvp";
          } else if (element.type !== "" && element.positiontype == "2") {
            finalValue = "(Star)";
            // return "star";
          } else if (element.type !== "" && element.positiontype == "3") {
            finalValue = "(Pro)";
            // return "pro";
          } else if (element.type !== "" && element.positiontype == "4") {
            finalValue = "(Util)";
            // return "util";
          } else if (element.type !== "" && element.positiontype == "5") {
            finalValue = "(Util2)";
            // return "util2";
          }
        }
      });
      //console.log('positionType', finalValue);
      return finalValue;
    },

    //* lock player...
    async lockExposure(event, player) {
      // request parameters
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }
      let payload = {
        user: this.userId,
        min: 100,
        max: 100,
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "lock" ? "" : "lock",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "",
        position: this.$store.state.NbaModule.position,
      };

      await this.$store.dispatch("NbaModule/SetExposure", payload).then(() => {
        // update player info locally
        this.updatePlayerInfo(payload);
      });
    },

    // * unlock player...
    async unlockExposure(event, player) {
      let payload = {
        playerId: player.PlayerID,
        user: this.userId,
        type: player.type == "lock" ? "" : "lock",
        slatId: this.slateID,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "01234",
        position: this.$store.state.NbaModule.position,
      };
      await this.$store
        .dispatch("NbaModule/unlockPlayers", payload)
        .then(() => {
          this.updatePlayerInfo(payload);
        });
    },

    // * set exposure...
    async setExposure(event, player) {
      // check if min and max value not set
      // if (player.min != "" && player.max != "") {
      // request parameter
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }

      let payload = {
        user: this.userId,
        min: player.min,
        max: player.max,
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: "manual",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "",
        position: this.$store.state.NbaModule.position,
      };

      await this.$store.dispatch("NbaModule/SetExposure", payload).then(() => {
        // update player info locally
        this.updatePlayerInfo(payload);
        /*let params = `${this.slateID}/${this.userId}`;
              await this.$store.dispatch("NbaModule/getPlayer", params);*/
      });
      // }
    },

    // * set exclude...
    async setExclude(event, player) {
      // request parameters
      let salary = 0;
      if (this.slates[0].Operator == "DraftKings") {
        salary = player.DraftKingsSalary;
      } else if (this.slates[0].Operator == "FanDuel") {
        salary = player.FanDuelSalary;
      }
      let payload = {
        user: this.userId,
        min: "",
        max: "",
        slatId: this.slateID,
        playerId: player.PlayerID,
        teamId: player.TeamID,
        type: player.type == "" ? "exclude" : "",
        slatePlayerID: player.SlatePlayerID,
        sallary: salary,
        playerrandomid: player.playerrandomid ? player.playerrandomid : "",
        position: this.$store.state.NbaModule.position,
      };

      //? dispatch event
      await this.$store
        .dispatch("NbaModule/SetExposure", payload)
        .then(async () => {
          // update player info locally
          this.updatePlayerInfo(payload);
          /*let params = `${this.slateID}/${this.userId}`;
                await this.$store.dispatch("NbaModule/getPlayer", params);*/
        });
    },

    // * setTopPlays...
    topPlays(event, player) {
      let position = "";
      if (this.slates[0].Operator == "DraftKings") {
        position = player.DraftKingsPosition;
      } else if (this.slates[0].Operator == "FanDuel") {
        position = player.FanDuelPosition;
      }

      let payload = {
        user: this.userId,
        SlateID: this.slateID,
        playerId: player.PlayerID,
        position: position,
        slatePlayerID: player.SlatePlayerID,
        isChecked: player.isChecked,
      };
      //console.log('event', typeof event, event);

      // * check for sports type...

      //? dispatch event...
      this.$store.dispatch("NbaModule/SetTopPlays", payload).then(() => {
        this.updatePlayerInfo(payload);

        let obj = {
          clientid: this.userId,
          slatId: this.slateID,
        };
        // ? getTopPlays
        this.$store.dispatch("NbaModule/GetTopPlays", obj);
      });
    },

    updatePlayerInfo(player) {
      // player index
      if (
        this.slates[0]?.Operator == "DraftKings" &&
        this.$parent.radio == "others"
      ) {
        // //console.log("check is working for other");
        let index = this.playerDetails.findIndex(
          (_player) => _player.playerrandomid === player.playerrandomid
        );
        if (index !== -1) {
          //check if player found in list
          let player_Info = this.playerDetails[index];
          Object.assign(player_Info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerDetails.splice(index, 1, player_Info);
        }
      } else if (
        this.slates[0]?.Operator == "FanDuel" &&
        this.$parent.radio == "others"
      ) {
        let index = this.playerDetails.findIndex(
          (_player) => _player.playerrandomid === player.playerrandomid
        );
        if (index !== -1) {
          //check if player found in list
          let player_Info = this.playerDetails[index];
          Object.assign(player_Info, {
            min: player.min,
            max: player.max,
            type: player.type,
          });
          // update the player
          this.playerDetails.splice(index, 1, player_Info);
        }
      } else {
        // //console.log("check is working for classic");
        let index = this.playerDetails.findIndex(
          (_player) => _player.PlayerID === player.playerId
        );
        // check if player found in list
        if (index !== -1) {
          let player_info = this.playerDetails[index];
          Object.assign(player_info, {
            min: player.min,
            max: player.max,
            type: player.type,
            isChecked: player.isChecked,
          });
          // update the player
          this.playerDetails.splice(index, 1, player_info);
        }
      }
    },
  },
};
</script>

<style scoped>
.minimun {
  font-size: 0.9em;
  max-width: 120px;
}
.maximum {
  font-size: 0.9em;
  max-width: 120px;
}
.v-input.v-input--hide-details.theme--light.v-input--selection-controls.v-input--checkbox {
  margin-top: -10px;
  margin-right: -15px;
}
</style>
